import { formatTokenAmount } from "features/wallet/utils/tokenAmount";
import usePointFindBy from "features/points/hooks/usePointFindBy";

export interface UsePointsBalanceParams {
    balance: string;
    isLoading?: boolean;
}

export default function usePointsBalance({ balance, isLoading: isLoadingProp }: UsePointsBalanceParams) {
    const { data: { decimals } = {}, isLoading: isLoadingPointInfo } = usePointFindBy();
    const pointsBalance = formatTokenAmount(balance, decimals || 0);
    const isLoading = isLoadingProp || isLoadingPointInfo;

    return {
        balance: pointsBalance,
        isLoading,
    };
}
